/**
 *
 * @file Makes sure images in a referenceContainer are always shown in cover mode
 * @author michael.schmid@notch-interactive.com
 * @param {object}  options - overwrites default settings (optional)
 *
 * Please make sure to add position: absolute and position:relative and overflow:hidden on the container
 *
 * */

import resizeManager from '../helpers/resize-manager';
import coverDimensions from '../helpers/cover-dimensions';
import debounce from 'debounce';

const defaults = {
    minWidth: 0
};


export default (options) => {

    /*
     * @param {string=} options.teaserImage - All images that shall enter cover mode
     * @param {string=} options.referenceContainer - Container that is covered by image
     * @param {string=} options.minWidth - Cover mode is only working from that breakpoint on
     */

    const instance = {},
        settings = Object.assign({}, defaults, options);

    let teaserImages = [],
        cover,
        referenceContainer,
        resizeReference,

        updateCover = () => {
            let image;

            teaserImages = document.querySelectorAll(settings.teaserImage);

            for (let i = teaserImages.length; i--;) {
                image = teaserImages[i];

                referenceContainer = image.closest(settings.referenceContainer);

                if (window.innerWidth >= settings.minWidth) {

                    // Clear this properties. Makes sure we get the right dimensions of the image.
                    image.style.width = '';
                    image.style.height = '';

                    cover = coverDimensions(image.width, image.height, referenceContainer.offsetWidth, referenceContainer.offsetHeight);

                    // apply calculated dimensions
                    image.style.top = cover.top + 'px';
                    image.style.left = cover.left + 'px';
                    image.style.height = cover.scaledHeight + 'px';
                    image.style.width = cover.scaledWidth + 'px';

                    referenceContainer.classList.remove('no-covermode');
                    referenceContainer.classList.add('covermode');
                } else {
                    image.removeAttribute('style');

                    referenceContainer.classList.remove('covermode');
                    referenceContainer.classList.add('no-covermode');
                }
            }
        },

        debouncedUpdate = debounce(updateCover, 50),

        bindEvents = () => {
            resizeReference = resizeManager.add(debouncedUpdate);
        },

        unbindEvents = () => {
            resizeManager.remove(resizeReference);
            resizeReference = null;
        };

    bindEvents();

    // initial state
    updateCover();

    // public methods
    instance.refreshElements = updateCover;

    /**
     * Destroys module
     */
    instance.destroy = () => {
        let image;

        teaserImages = document.querySelectorAll(settings.teaserImage);

        for (let i = teaserImages.length; i--;) {
            image = teaserImages[i];

            referenceContainer = image.closest(settings.referenceContainer);
            image.removeAttribute('style');
            referenceContainer.classList.remove('covermode');
            referenceContainer.classList.add('no-covermode');
        }

        unbindEvents();
    };

    return instance;
};
